// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"App_mainContent__2BuLa","footer":"App_footer__29Fsv","checkboxSelection":"App_checkboxSelection__33mgH"};